import styled from 'styled-components';

export const LinkFooter = styled.a`
  text-decoration: none;
  font-style: italic;
  color: rgb(236,76,138);
`;

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #000;
  margin: 1rem;
`;
